function injectStyle (context) {
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"id\":\"data-v-fefd846c\",\"scoped\":true,\"sourceMap\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":\"/usr/src/app/scss/no-styles.scss\"}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WellPreviewImage.vue")
}
/* script */
export * from "!!!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./WellPreviewImage.vue"
import __vue_script__ from "!!!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./WellPreviewImage.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-fefd846c\",\"hasScoped\":true,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./WellPreviewImage.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fefd846c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports
